import { VALIDATION_CODE } from '~publish/legacy/validation/constants'

import type { ValidationCode, ValidationFeedback } from './types'
import type { Draft } from '../entities/Draft'
import * as ValidatorFactory from '../lib/validation/ValidatorFactory'

type Input = { drafts: Draft[]; isDraft: boolean; activeThreadId?: number }
export const getDraftsFeedback = ({
  drafts,
  isDraft = false,
  activeThreadId = undefined,
}: Input): ValidationFeedback[] => {
  return drafts.reduce<ValidationFeedback[]>((invalidDraftsFeedback, draft) => {
    const validationErrors = ValidatorFactory.validate(
      draft,
      isDraft,
      activeThreadId,
    ).toObject()

    if (validationErrors.length > 0) {
      invalidDraftsFeedback.push(...validationErrors)
    }
    return invalidDraftsFeedback
  }, [])
}

// Message codes for which feedback shouldn't be displayed inside the composer
const whatPreventsSavingIgnoredCodes: ReadonlySet<ValidationCode> = new Set([
  VALIDATION_CODE.CHARACTER_LIMIT_REACHED,
])

export const getComposerFeedbackMessages = (
  whatPreventsSaving: readonly ValidationFeedback[],
  composerId: string,
): ValidationFeedback[] =>
  whatPreventsSaving.filter(
    (what) =>
      what.composerId === composerId &&
      what.code &&
      !whatPreventsSavingIgnoredCodes.has(what.code),
  )

export const isASmallScreen = (): boolean => {
  return window.innerWidth <= 1464
}
